
import React from 'react';
import { BrowserRouter } from "react-router-dom";
import Routes from './Routes';
import { GlobalContext } from './_contexts';
import "./styles.scss";

function App({
  globalVars,
}) {

  return (
    <GlobalContext.Provider value={globalVars}>
      <BrowserRouter>
        <Routes/>
      </BrowserRouter>
    </GlobalContext.Provider>
  );
};

export default App;
